import "../../styles/all.css"
import "../../styles/theme.css"
import "./progress.css"
function Goal(){
    return(
        <>
        <div className="goal">
             <div className="startt">
                <h4>Goal Progress</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="cards">
                <div className="row">
                   <div className="col-md-6 text-center">
  <div className="circleone" data-percent="44">
    <span>44%</span>
  </div>

  <h4>Marketing Goal</h4>
  <h6>$550 / $1250 USD</h6>
</div>
                   <div className="col-md-6 text-center">
  <div className="circletwo" data-percent="74">
    <span>74%</span>
  </div>

  <h4>Team Goal</h4>
  <h6>$550 / $1250 USD</h6>
</div>
                   <div className="col-md-6 text-center">
  <div className="circlethree" data-percent="44">
    <span>100%</span>
  </div>

  <h4>Leads Goal</h4>
  <h6>$850 / $950 USD</h6>
</div>
                   <div className="col-md-6 text-center">
  <div className="circlefour" data-percent="44">
    <span>100%</span>
  </div>

  <h4>Revenue Goal</h4>
  <h6>$5,655 / $1200 USD</h6>
</div>

                </div>
            </div>
            <div className="button">
                <button className="btn btn-primary w-100 mt-5">Generate Reports</button>
            </div>
        </div>
        </>
    )
}
export default Goal